"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

/**
Dropdown Hooks, like the file name says
Handles management of open/close state
Adding/removing CSS classes to body/html
*/
function useDropdownState(params) {
  if (params === void 0) {
    params = {};
  }

  var _params = params,
      initialOpen = _params.open,
      onToggle = _params.onToggle; // state for open/close state

  var _useState = (0, _react.useState)(initialOpen),
      open = _useState[0],
      setOpen = _useState[1]; // ref for dropdown


  var componentRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    setOpen(initialOpen);
  }, [initialOpen]); // reset state if open prop changes

  var onClickOutside = (0, _react.useCallback)(function (e) {
    if (open && !componentRef.current.contains(e.target)) {
      if (typeof onToggle === 'function') onToggle(false);
      setOpen(false);
    }
  }, [setOpen, onToggle, open]);
  (0, _react.useEffect)(function () {
    window.addEventListener('click', onClickOutside);
    return function () {
      return window.removeEventListener('click', onClickOutside);
    };
  }, [onClickOutside]); // listener for when user clicks outside dropdown

  function toggleDropdown() {
    if (typeof onToggle === 'function') onToggle(!open);
    setOpen(!open);
  }

  function openDropdown() {
    onToggle(open);
    setOpen(true);
  }

  function closeDropdown() {
    onToggle(false);
    setOpen(false);
  }

  return {
    open: open,
    setOpen: setOpen,
    componentRef: componentRef,
    openDropdown: openDropdown,
    closeDropdown: closeDropdown,
    toggleDropdown: toggleDropdown
  };
}

var _default = useDropdownState;
exports["default"] = _default;